/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ContentCard } from './ContentCard'
import { ContentCardFromJSON, ContentCardFromJSONTyped, ContentCardToJSON } from './ContentCard'
import type { CustomContentJSON } from './CustomContentJSON'
import {
  CustomContentJSONFromJSON,
  CustomContentJSONFromJSONTyped,
  CustomContentJSONToJSON,
} from './CustomContentJSON'

/**
 * Adds update nested feature
 * @export
 * @interface Content
 */
export interface Content {
  /**
   *
   * @type {number}
   * @memberof Content
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof Content
   */
  readonly slug: string
  /**
   *
   * @type {string}
   * @memberof Content
   */
  header?: string | null
  /**
   *
   * @type {CustomContentJSON}
   * @memberof Content
   */
  otherData?: CustomContentJSON | null
  /**
   * * `category` - Category
   * * `object` - Object
   * * `service` - Service
   * * `static_page` - Static Page
   * @type {string}
   * @memberof Content
   */
  readonly type: ContentTypeEnum
  /**
   *
   * @type {number}
   * @memberof Content
   */
  entityId?: number | null
  /**
   *
   * @type {number}
   * @memberof Content
   */
  readonly regionId: number | null
  /**
   *
   * @type {boolean}
   * @memberof Content
   */
  usedDefault?: boolean
  /**
   *
   * @type {Array<ContentCard>}
   * @memberof Content
   */
  cards?: Array<ContentCard>
  /**
   *
   * @type {string}
   * @memberof Content
   */
  iconImg?: string | null
}

/**
 * @export
 */
export const ContentTypeEnum = {
  Category: 'category',
  Object: 'object',
  Service: 'service',
  StaticPage: 'static_page',
} as const
export type ContentTypeEnum = (typeof ContentTypeEnum)[keyof typeof ContentTypeEnum]

/**
 * Check if a given object implements the Content interface.
 */
export function instanceOfContent(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'slug' in value
  isInstance = isInstance && 'type' in value
  isInstance = isInstance && 'regionId' in value

  return isInstance
}

export function ContentFromJSON(json: any): Content {
  return ContentFromJSONTyped(json, false)
}

export function ContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Content {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    slug: json['slug'],
    header: !exists(json, 'header') ? undefined : json['header'],
    otherData: !exists(json, 'otherData')
      ? undefined
      : CustomContentJSONFromJSON(json['otherData']),
    type: json['type'],
    entityId: !exists(json, 'entityId') ? undefined : json['entityId'],
    regionId: json['regionId'],
    usedDefault: !exists(json, 'usedDefault') ? undefined : json['usedDefault'],
    cards: !exists(json, 'cards')
      ? undefined
      : (json['cards'] as Array<any>).map(ContentCardFromJSON),
    iconImg: !exists(json, 'iconImg') ? undefined : json['iconImg'],
  }
}

export function ContentToJSON(value?: Content | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    header: value.header,
    otherData: CustomContentJSONToJSON(value.otherData),
    entityId: value.entityId,
    usedDefault: value.usedDefault,
    cards:
      value.cards === undefined ? undefined : (value.cards as Array<any>).map(ContentCardToJSON),
    iconImg: value.iconImg,
  }
}
